import { fmhAPI, USER_SUPPORT_API_URL } from 'api/APIBase';

// User
export async function registerCurrentUser({ details }) {
    const url = `${USER_SUPPORT_API_URL}/admin/users/register`;
    return fmhAPI.base.url(url).post(details).json();
}

export async function updateUserDetails({ details }) {
    const url = `${USER_SUPPORT_API_URL}/admin/users`;
    return fmhAPI.base.url(url).put(details).json();
}

// Notes
export async function findNotes({ referralId, searchTerm = undefined }) {
    const url = `${USER_SUPPORT_API_URL}/admin/notes`;
    return fmhAPI.base
        .url(url)
        .query({
            referral_id: referralId,
            ...(searchTerm
                ? {
                      search_term: searchTerm,
                  }
                : {}),
        })
        .get()
        .json();
}

export async function getNoteById({ conversationId }) {
    const url = `${USER_SUPPORT_API_URL}/admin/notes/${conversationId}`;
    return fmhAPI.base.url(url).get().json();
}

export async function createNote({ referralId, details }) {
    const url = `${USER_SUPPORT_API_URL}/admin/notes/referral/${referralId}`;
    return fmhAPI.base.url(url).post(details).json();
}

export async function archiveNote({ conversationId }) {
    const url = `${USER_SUPPORT_API_URL}/admin/notes/${conversationId}/archive`;
    return fmhAPI.base.url(url).put().json();
}

// Messages
export async function postMessage({ conversationId, details }) {
    const url = `${USER_SUPPORT_API_URL}/admin/messages/${conversationId}`;
    return fmhAPI.base.url(url).post(details).json();
}

export async function softDeleteMessage({ messageId }) {
    const url = `${USER_SUPPORT_API_URL}/admin/messages/${messageId}/delete`;
    return fmhAPI.base.url(url).put().json();
}
